export default function () {
  const fullImages = document.querySelectorAll('.full-image');

  if (!fullImages.length) return;

  function watchWindowScroll() {
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    fullImages.forEach((section) => {
      const { top, height } = section.getBoundingClientRect();
      if (windowHeight < top || top + height < 0) return;

      const img = section.querySelector('.full-image__img');
      const pos = - windowWidth / 10 * ((top + height) / (windowHeight + height) * 2 - 1);
      img.style.transform = `translate3d(0, ${pos}px, 0)`;
    });
  }

  function initParallax() {
    if (window.innerWidth < 768) {
      window.removeEventListener('scroll', watchWindowScroll);
      fullImages.forEach((section) => {
        const img = section.querySelector('.full-image__img');
        img.style.transform = '';
      });
    } else {
      window.addEventListener('scroll', watchWindowScroll);
      watchWindowScroll();
    }
  }

  window.addEventListener('widthResize', () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initParallax()
      });
    });
  });

  initParallax();
}
